import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";

import 'swiper/css';


import { Autoplay } from 'swiper/modules';

export default function SliderHomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 8500,
                    disableOnInteraction: false,
                }}

                modules={[Autoplay]}
                className="mySwiper"
                style={{ overflow: "hidden", marginTop: "" }}
            >
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="hero-slider-wrapper-1">
                            <div className="container container-1560">
                                <div className="row">
                                    <div className="col-12 col-sm-9 col-lg-7 col-xl-6 col-xxl-5" style={{ marginTop: "-100px" }}>
                                        <div className="section-content-block">
                                            <span className="section-tag is-white-transparent">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="hero-title text-light"> <strong>Your Trusted Logistics Partner</strong></h2>
                                            <p className="section-text text-light mb-5">If you are looking for an impeccable Transportation service in India, you can contact us. We welcome your call & queries. </p>
                                            <div className="d-flex align-items-center gap-4 flex-wrap mt-5">
                                                <Link to="/track-order" className="btn btn-secondary-alt">
                                                    Track Order
                                                    <div className="btn-icon">
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slider-bg-1">
                                <img src="assets/images/hero-2-slider-bg-3.webp" alt="hero-2-slider-bg-3" width={1840} height={860} className="image-cover" />
                            </div>
                            <div className="hero-1-slider-overlay" />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="hero-slider-wrapper-1">
                            <div className="container container-1560">
                                <div className="row">
                                    <div className="col-12 col-sm-9 col-lg-7 col-xl-6 col-xxl-5" style={{ marginTop: "-100px" }}>
                                        <div className="section-content-block">
                                            <span className="section-tag is-white-transparent">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="hero-title text-light"> <strong>The company operates from Jabalpur Road, Katni</strong></h2>
                                            <p className="section-text text-light mb-5">If you are looking for an impeccable Transportation service in India, you can contact us. We welcome your call & queries. </p>
                                            <div className="d-flex align-items-center gap-4 flex-wrap mt-5">
                                                <Link to="/track-order" className="btn btn-secondary-alt">
                                                    Track Order
                                                    <div className="btn-icon">
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                    </div>
                                                </Link>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slider-bg-1">
                                <img src="assets/images/hero-2-slider-bg-2.webp" alt="hero-2-slider-bg-2" width={1840} height={860} className="image-cover" />
                            </div>
                            <div className="hero-1-slider-overlay" />
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="hero-slider-wrapper-1">
                            <div className="container container-1560">
                                <div className="row">
                                    <div className="col-12 col-sm-9 col-lg-7 col-xl-6 col-xxl-5" style={{ marginTop: "-100px" }}>
                                        <div className="section-content-block">
                                            <span className="section-tag is-white-transparent">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="hero-title text-light"> <strong>Your Trusted Logistics Partner</strong></h2>
                                            <p className="section-text text-light mb-5">If you are looking for an impeccable Transportation service in India, you can contact us. We welcome your call & queries. </p>

                                            <div className="d-flex align-items-center gap-4 flex-wrap mt-5">

                                                <Link to="/track-order" className="btn btn-secondary-alt">
                                                    Track Order
                                                    <div className="btn-icon">
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slider-bg-1">
                                <img src="assets/images/hero-2-slider-bg-1.webp" alt="hero-2-slider-bg-1" width={1840} height={860} className="image-cover" />
                            </div>
                            <div className="hero-1-slider-overlay" />
                        </div>
                    </div>
                </SwiperSlide>

            </Swiper>
        </>
    );
}
